import { CouponActionTypes } from "./coupon.type";

const INITIAL_STATE = {
  coupons: [],
  totalCoupons: 0,
  currentCoupon: null,
};

const couponReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Fetch coupons
    case CouponActionTypes.GET_COUPONS:
      return {
        ...state,
        coupons: action.payload.coupons,
        totalCoupons: action.payload.total,
      };

    // Add coupon
    case CouponActionTypes.ADD_COUPON:
      return {
        ...state,
        coupons: [action.payload, ...state.coupons],
        totalCoupons: state.totalCoupons + 1,
      };

    // Update coupon
    case CouponActionTypes.UPDATE_COUPON:
      return {
        ...state,
        coupons: state.coupons.map((coupon) =>
          coupon._id === action.payload._id ? action.payload : coupon,
        ),
        currentCoupon: null,
      };

    // Delete coupon
    case CouponActionTypes.DELETE_COUPON:
      return {
        ...state,
        coupons: state.coupons.filter(
          (coupon) => coupon._id !== action.payload,
        ),
        totalCoupons: state.totalCoupons - 1,
      };

    case CouponActionTypes.EDITING_COUPON:
      return {
        ...state,
        currentCoupon: action.payload,
      };

    default:
      return state;
  }
};

export default couponReducer;
